import * as userAction from "../actions/askaquestion.action";
const user = (
  state = {
    status: null,
    loading: false,
    error: null,
    postResponse: null,
  },
  action,
) => {
  switch (action.type) {
    case userAction.ASK_A_QUESTION_REQUEST:
      return Object.assign({}, state, {
        status: action.status,
        loading: true,
      });
    case userAction.ASK_A_QUESTION_SUCCESS:
      return Object.assign({}, state, {
        postResponse: action.postResponse,
        status: action.status,
        loading: false,
      });
    case userAction.ASK_A_QUESTION_FAILURE:
      return Object.assign({}, state, {
        error: action.error,
      });
    case userAction.ASK_A_QUESTION_CLEAR:
      return Object.assign({}, state, {
        postResponse: action.postResponse,
        status: action.status,
        loading: false,
      });
    default:
      return state;
  }
};
export default user;
